import React from 'react';
import { FaTimes } from 'react-icons/fa';
import Select from 'react-select';
import Const from '../../util/Constants';
import { reactLocalStorage } from 'reactjs-localstorage';

class ColdSelectFilter extends React.Component {
   static conditionOptions = [
    { value: "equals", label: "Equals" },
    { value: "not-equals", label: "Not Equals" },
    { value: "in", label: "Contains" },
    { value: "not-in", label: "Does Not Contains" },
    { value: "empty", label: "Empty" },
    { value: "not-empty", label: "Not Empty" },
  ];

  constructor(props) {
    super(props);
    const f = props.filter;
    const condition = f
      ? ColdSelectFilter.conditionOptions.find(c => c.value === f.condition) || null
      : ColdSelectFilter.conditionOptions[2];

    const selected = f && f.value
      ? props.options?.filter(opt =>
          f.value.includes(`~${opt.value}~`)
        )
      : [];

    this.state = { condition, selected };
    const models = reactLocalStorage.getObject(Const.Model);
    this.feedbackOptions = models?.[Const.TextCall]?.fields?.feedback?.options ?? [];
  }

  componentDidUpdate(prevProps) {
    // Reset when parent clears all filters
    if (prevProps.filter && !this.props.filter) {
      this.setState({ condition: null, selected: [] });
    }
  }

  onConditionChanged = select => {
    this.setState({ condition: select, selected: [] });

    const noValue = select.value === 'empty' || select.value === 'not-empty';
    if (noValue) {
      this.props.onValueChange(this.props.field.field_key, select.value, '');
    } else {
      // this.props.deleteFilter(this.props.field.field_key);
    }
  };

  onOptionChange = selected => {
    this.setState({ selected });

    if (selected && selected.length > 0) {
      // Encode as "~val1~val2~" to match the pattern used across filter components
      const value = '~' + selected.map(s => s.value).join('~') + '~';
      this.props.onValueChange(
        this.props.field.field_key,
        this.state.condition.value,
        value
      );
    } else {
      // this.props.deleteFilter(this.props.field.field_key);
    }
  };

  onReset = () => {
    this.setState({ condition: ColdSelectFilter.conditionOptions[2], selected: [] });
    this.props.resetFilter(this.props.field.field_key);
  };

  render() {
    const { field } = this.props;
    const { condition, selected } = this.state;
    const conditionValue = condition ? condition.value : '';
    const noValueNeeded  = conditionValue === 'empty' || conditionValue === 'not-empty';
    const showSelect     = condition && !noValueNeeded;
    const isActive       = (selected && selected.length > 0) || noValueNeeded;

    return (
      <>
        <div className="row pt-2">
          <div className="col-md-5">
            <p className="headingp">{field.label_name}</p>
          </div>
          <div className={`col-md-${isActive ? 5 : 7}`}>
            <Select
              value={condition}
              onChange={this.onConditionChanged}
              options={ColdSelectFilter.conditionOptions}
              isSearchable={true}
              placeholder="Select..."
            />
          </div>
          {isActive && (
            <div className="col-md-1">
              <FaTimes style={{ cursor: 'pointer' }} onClick={this.onReset} />
            </div>
          )}
        </div>

        {showSelect && (
          <div className="row pt-2">
            <div className="col-md-12">
              <Select
                value={selected}
                onChange={this.onOptionChange}
                options={this.feedbackOptions}
                isSearchable={true}
                isClearable={true}
                isMulti={true}
                placeholder="Select options..."
              />
            </div>
          </div>
        )}
        <hr />
      </>
    );
  }
}

export { ColdSelectFilter };